import Vue from 'vue';
import Router from 'vue-router';
import {
  commonRouter,
  personalRouter,
  exRouter,
} from 'BlockChain-ui-privatization/PC/router';
import { setCookie, routerEnv } from '@/utils';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

const evnConfig = ['kz', 'ex', 'otc', 'co'];

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    // 矿渣
    {
      path: `${routerEnv}/kzHome`,
      name: 'kzHome',
      meta: {
        pageTitle: 'kzHome',
        theme: 'homeOther',
        navigation: '1', // 国际版中使用横向导航
        footNotMrgin: true,
        hideFooter: 'false', // 不隐藏footer
        H5HideCommonHeader: true, // H5 隐藏公共导航
        isCoOpen: true,
      },
      component: () => import('@/views/kz/home/index.vue'),
    },
    // 创新试验区详情
    {
      path: `${routerEnv}/innovation/:id`,
      name: 'innovationView',
      meta: {
        mustLogin: false,
        theme: 'homeOther',
        navigation: '1', // 国际版中使用横向导航
        hideFooter: 'false', // 不隐藏footer
        pageTitle: 'innovation',
      },
      component: () => import('@/views/innovation/view.vue'),
    },
    // 投票
    {
      path: `${routerEnv}/vote`,
      name: 'vote',
      meta: {
        mustLogin: false,
        theme: 'homeOther',
        navigation: '1', // 国际版中使用横向导航
        hideFooter: 'false', // 不隐藏footer
        pageTitle: 'innovation',
      },
      component: () => import('@/views/mining/vote/index.vue'),
    },
    // vdex手续费查询
    {
      path: `${routerEnv}/feeDetail`,
      name: 'feeDetail',
      meta: {
        mustLogin: false,
        theme: 'homeOther',
        navigation: '1', // 国际版中使用横向导航
        hideFooter: 'false', // 不隐藏footer
        pageTitle: 'innovation',
      },
      component: () => import('@/views/mining/feeDetail/index.vue'),
    },
    ...commonRouter,
    // 个人中心
    ...personalRouter,
    ...exRouter,
  ],
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  },
});
if (process.env.NODE_ENV === 'development') {
  router.beforeEach((to, from, next) => {
    const fromPathArr = from.path.split('/');
    const toPathArr = to.path.split('/');
    let [, fromHostEnv, fromLan] = fromPathArr;
    const [, toHostEnv, toLan] = toPathArr;
    const reg = /^[a-z]{2}_[A-Z]{2}$/;
    if ((evnConfig.indexOf(toHostEnv) !== -1) && reg.test(toLan)) {
      setCookie('lan', toLan);
      next();
    } else {
      if (from.path === '/') {
        let ev = '';
        evnConfig.forEach((item) => {
          const fit = `/${item}/`;
          if (to.path.indexOf(item) !== -1) {
            ev = fit;
          }
        });
        const str = `${ev}en_US/${to.path.split(ev)[1]}`;
        setCookie('lan', 'en_US');
        next(str);
        return false;
      }
      let str = '';
      fromHostEnv = evnConfig.indexOf(fromHostEnv) !== -1 ? fromHostEnv : 'ex';
      fromLan = reg.test(fromLan) ? fromLan : 'en_US';
      if (evnConfig.indexOf(toHostEnv) === -1) {
        str += `/${fromHostEnv}`;
      }
      if (!reg.test(toLan)) {
        str += `/${fromLan}`;
      }
      str += to.fullPath;
      setCookie('lan', fromLan);
      next(str);
    }
    return false;
  });
} else {
  const reg = /^[a-z]{2}_[A-Z]{2}$/;
  router.beforeEach((to, from, next) => {
    if (from.path === '/') {
      next();
    } else {
      const fromPathArr = from.path.split('/');
      const fromLan = fromPathArr[1];
      const toPathArr = to.path.split('/');
      const toLan = toPathArr[1];
      if (reg.test(toLan)) {
        next();
      } else {
        const toPath = `/${fromLan}${to.fullPath}`;
        next(toPath);
      }
    }
  });
}
// 跳转页面 到顶部
// router.afterEach(() => {
//   window.scrollTo(0, 0);
// });

export default router;
